export default "__VITE_ASSET__B93oFm_$__"